export default {
  BOARD: 'Board',
  BOARD_ADD_COLUMN: 'Add Column',
  BOARD_ADD_TO_ANOTHER_BOARD: 'Add to another board',
  BOARD_CATEGORY_EMPTY_TITLE: 'No Constituents in {title}',
  BOARD_CATEGORY_EMPTY_DESCRIPTION_0:
    'Donors you are currently researching, screening, and categorizing on inclination, capacity, and readiness.',
  BOARD_CATEGORY_EMPTY_DESCRIPTION_1:
    'Top donors you are evaluating based on greatest inclination, capacity, and readiness.',
  BOARD_CATEGORY_EMPTY_DESCRIPTION_2:
    'Donors that are in development, scheduling appointments, and receiving requests.',
  BOARD_CATEGORY_EMPTY_DESCRIPTION_3:
    'Follow up with donors to convey gratitude and provide ongoing insight into the impact their gift will create.',
  BOARD_CLEAR_FILTERS: 'Clear Filters',
  BOARD_CLICK_TO_EDIT: 'Click to edit column info',
  BOARD_COLUMN: 'Column',
  BOARD_COLUMN_TITLE: 'Column title',
  BOARD_COLUMN_DESCRIPTION: 'Column description',
  BOARD_CREATE_NEW: 'Create New Board',
  BOARD_DEFAULT_EMPTY_DESCRIPTION:
    'You have not assigned any constituents to this column yet.',
  BOARD_DEFAULT_EMPTY_TITLE: 'No Constituents Added',
  BOARD_DELETE: 'Delete Board',
  BOARD_DELETE_CONFIRMATION:
    'Are you sure you want to delete the "{boardTitle}" board?',
  BOARD_EDIT: 'Edit Board',
  BOARD_EDIT_COLUMN_INFO: 'Edit Column Info',
  BOARD_EMPTY_LIST: 'There are no Lifecycle Boards',
  BOARD_LABEL_NAME: 'Board Name',
  BOARD_REMOVE_COLUMN: 'Remove Column',
  BOARD_REMOVE_COLUMN_CONFIRMATION_DESCRIPTION:
    'Are you sure want to remove the {column} column? Any Constituents in this column will be removed from the board.',
  BOARD_REMOVE_COLUMN_CONFIRMATION_TITLE: 'Remove Column',
  BOARD_REMOVE_CONSTITUENT: 'Remove constituent from board',
  BOARD_SELECT_BOARD_AND_COLUMN:
    'Select board and column to add constituent to',
  BOARD_TAP_TO_EDIT: 'Tap to edit column info',
  BOARD_SELECT_ALL_CONSTITUENTS_IN_COLUMN: 'Select All Constituents',
  BOARD_SELECT_BOARD: 'Select Board',
  BOARD_SELECT_COLUMN: 'Select Column',
  LIFECYCLE_BOARD: 'Lifecycle Board',
  LIFECYCLE_BOARD_COLUMN: 'Lifecycle Board Column',
};
